import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import { Box, Button, CssBaseline, Toolbar, Typography } from "@mui/material";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AssignmentIcon from '@mui/icons-material/Assignment';
import GroupIcon from '@mui/icons-material/Group';
import { useLocation, useHistory } from "react-router-dom";
import NavBar from "../DashboardLayout/NavBar";
import TopBar from "../DashboardLayout/TopBar";



const useStyles = makeStyles((theme) => ({
    root: {
        background: "#000",
        display: "flex",
        height: "100%",
        overflow: "hidden",
        width: "100%",
        minHeight: "100vh",
    },
    wrapper: {
        display: "flex",
        flex: "1 1 auto",
        overflow: "hidden",
        height: "100%",
        width: "100%",
        backgroundImage: 'url("/images/dashboardbg.png")',
        background: "black",
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        [theme.breakpoints.up("lg")]: {
            paddingLeft: 256,
        },
    },
    contentContainer: {
        display: "flex",
        flex: "1 1 auto",
        overflow: "hidden",
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        maxWidth: "100%",
        minHeight: "100vh",
    },
    content: {
        flex: "1 1 auto",
        height: "100%",
        overflow: "hidden",
        position: "relative",
        boxShadow: "-6px 0px 8px 0px #090909",
        WebkitOverflowScrolling: "touch",
        padding: "70px 30px",
        [theme.breakpoints.only('xs')]: {
            padding: "70px 10px 10px",
        },
        [theme.breakpoints.only('sm')]: {
            padding: "70px 10px 10px",
        },
    },
}));

const menuItems = [
    { text: 'Transactions', icon: <ListAltIcon fontSize="small" />, path: '/investment-dashboard/orders' },
    { text: 'SIPS', icon: <ListAltIcon fontSize="small" />, path: '/investment-dashboard/sips' },
    { text: 'SWPS', icon: <ListAltIcon fontSize="small" />, path: '/investment-dashboard/swps' },
    { text: 'STPS', icon: <ListAltIcon fontSize="small" />, path: '/investment-dashboard/stps' },
];

const DashboardLayout = ({ children }) => {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const [isMobileNavOpen, setMobileNavOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div className={classes.root}>
            <CssBaseline />
            <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
            <NavBar onMobileClose={() => setMobileNavOpen(false)} openMobile={isMobileNavOpen} />
            <div className={classes.wrapper}>
                <div className={classes.contentContainer}>
                    <div className={classes.content} id="main-scroll">
                        {/* Toolbar spacing */}
                        <Toolbar />
                        {/* Back Button */}
                        <Box sx={{ px: 2 }}>
                            <Typography variant="h5" fontWeight="bold" sx={{textAlign:"left", mb:3}}>
                                Orders
                            </Typography>
                            <Button
                                  onClick={() => history.push('/investment-portfolio')}
                                sx={{
                                    color: 'white',
                                    fontSize: '1rem',
                                    textTransform: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    mb: 2,
                                    p: 0,
                                }}
                            >
                                <ArrowBackIosIcon sx={{ fontSize: 'small', mr: 1 }} />
                                Back
                            </Button>
                        </Box>

                        {/* Horizontal Navigation Tabs */}
                        <Box
                            sx={{
                                display: 'flex',
                                overflowX: 'auto',
                                bgcolor: '#1a1a1a',
                                px: 2,
                                py: 1,
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                            }}
                        >
                            {menuItems.map((item) => (
                                <Button
                                    key={item.text}
                                    startIcon={item.icon}
                                    onClick={() => history.push(item.path)}
                                    sx={{
                                        mx: 1,
                                        color: location.pathname === item.path ? 'white' : 'gray',
                                        fontWeight: location.pathname === item.path ? 'bold' : 'normal',
                                        borderBottom: location.pathname === item.path ? '2px solid white' : 'none',
                                        whiteSpace: 'nowrap',
                                        minWidth: 'fit-content',
                                        borderRadius: 0,
                                        textTransform: 'none',
                                    }}
                                >
                                    {item.text}
                                </Button>
                            ))}
                        </Box>

                        {/* Children Route Content */}
                        <Box sx={{ mt: 3 }}>
                            {children}
                        </Box>
                    </div>
                </div>
            </div>
        </div>
    );
};

DashboardLayout.propTypes = {
    children: PropTypes.node,
};
export default DashboardLayout;
